import type React from 'react';

import type { IconProps } from 'types/icon';

const Spinner: React.FC<IconProps> = ({
  size = '16',
  color = 'currentColor',
  strokeWidth = '2',
  ...attributes
}) => {
  return (
    <svg
      className="animate-spin"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
      {...attributes}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
      />
      <circle
        className="opacity-75"
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray="47 16"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Spinner;
